export default __webpack_public_path__ + "static/media/trilloProject.a022a5a1.JPG";